import useScreenSize from '../../core/hooks/useScreenSize';
import {
  StyledBox,
  StyledOverlay,
  StyledIcon,
  StyledContainer,
  StyledBgImage,
  StyledImage,
  StyledLabel,
  StyledTextContent,
  StyledTitle,
  StyledDescription,
} from './CategoryBox.styles';

function CategoryBox({ data }) {
  const [size] = useScreenSize();
  const { url, photo, alt, description, title, color, overlay, icon } = data;

  if (!data.url) return null;

  return (
    <StyledBox>
      {url && photo && (
        <StyledContainer to={url}>
          {photo && (
            <StyledBgImage>
              {icon && size > 991 && <StyledIcon src={icon} />}
              {overlay && <StyledOverlay bgColor={overlay} />}
              <StyledImage src={photo} alt={alt} />
            </StyledBgImage>
          )}

          {color && <StyledLabel color={color} />}

          <StyledTextContent>
            {icon && size < 992 && <StyledIcon src={icon} />}
            {title && <StyledTitle>{title}</StyledTitle>}
            {size > 991 && description && <StyledDescription>{description}</StyledDescription>}
          </StyledTextContent>
        </StyledContainer>
      )}
    </StyledBox>
  );
}

CategoryBox.defaultProps = {
  data: {},
};

export default CategoryBox;
